import relatedCategoryFeaturedStoresConfig from '../configs';

/** @type {{config: object, merchants: array.<object>}} */
const initialState = {
  config: relatedCategoryFeaturedStoresConfig,
};

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const relatedCategoryFeaturedStores = (state = initialState) => state;

export default relatedCategoryFeaturedStores;
